import { setDocumentPageTitle } from "@repo/ui/documentTitle/documentTitle";
import { useEffect, type RefObject } from "react";

/** The browser-tab title: the page's own title, then the product. */
export function buildDocumentTitle(pageTitle: string) {
  return pageTitle ? `${pageTitle} | Alpharun` : "Alpharun";
}

/**
 * Keeps the page title on the current breadcrumb's text. It is read from the
 * trail rendered under `trailRef`, so an entity name counts once its crumb
 * label has loaded.
 */
export function useBreadcrumbDocumentTitle(
  trailRef: RefObject<HTMLElement | null>,
) {
  useEffect(() => {
    const trail = trailRef.current;
    if (!trail) {
      return;
    }
    const updateTitle = () => {
      const currentCrumb = trail.querySelector('[aria-current="page"]');
      const pageTitle = currentCrumb?.textContent?.trim() ?? "";
      setDocumentPageTitle(buildDocumentTitle(pageTitle));
    };
    updateTitle();
    const observer = new MutationObserver(updateTitle);
    observer.observe(trail, {
      subtree: true,
      childList: true,
      characterData: true,
      attributeFilter: ["aria-current"],
    });
    return () => {
      observer.disconnect();
      setDocumentPageTitle(buildDocumentTitle(""));
    };
  }, [trailRef]);
}
